/* eslint-disable max-lines-per-function */
import {
  Button,
  Card,
  CircularProgress,
  Icon,
  Table,
  Typography,
} from '@equinor/eds-core-react';
import {
  UploadFileType,
  UploadList,
  UploadStatus,
} from '../../../api/generated';
import * as Styled from './ModelFilesView.styled';
import { analogueModelDefault } from '../../../constants/analogueModelDefault';
import { useFetchModel } from '../../../hooks/useFetchModel';
import { download } from '@equinor/eds-icons';
import {
  GetFetchIniFileAxios,
  GetFetchNcFileAxios,
  GetFetchResqmlFileAxios,
} from '../../../hooks/useFetchFile';
import { useIsReader } from '../../../hooks/useIsReader';
import { useDownloadStore } from '../../../stores/DownloadStore';

export const ModelFilesView = () => {
  const { data: analogueModel = analogueModelDefault } = useFetchModel();
  const progress = useDownloadStore((s) => s.progress);
  const isReader = useIsReader();

  if (analogueModel === analogueModelDefault) return <p>Loading ...</p>;

  const downloadFile = async (fileType: UploadFileType) => {
    switch (fileType) {
      case UploadFileType.NET_CDF:
        await GetFetchNcFileAxios(analogueModel);
        break;
      case UploadFileType.INI_DATA:
        await GetFetchIniFileAxios(analogueModel);
        break;
      case UploadFileType.RES_QML_DATA:
        await GetFetchResqmlFileAxios(analogueModel);
        break;
    }
  };

  const iconButtons = (fileType: UploadFileType) => {
    const fileProgress = progress[fileType];
    if (fileProgress !== undefined)
      return (
        <Styled.ProgressWrapper>
          <CircularProgress
            color="primary"
            size={24}
            value={fileProgress}
            variant="determinate"
          />
          <p>{fileProgress}%</p>
        </Styled.ProgressWrapper>
      );

    return (
      <Button
        variant="ghost_icon"
        onClick={() => downloadFile(fileType)}
        disabled={isReader}
      >
        <Icon data={download} title={'download'} />
      </Button>
    );
  };

  return (
    <Card className="card-files">
      <Card.Header>
        <Typography variant="h4" as="h3" className="card-title">
          Model files
        </Typography>
      </Card.Header>
      <Card.Content>
        <Styled.TableWrapper>
          <Styled.FileTable>
            <Table.Head>
              <Table.Row className="table-row">
                <Table.Cell>File name</Table.Cell>
                <Table.Cell>Size</Table.Cell>
                <Table.Cell>Download</Table.Cell>
              </Table.Row>
            </Table.Head>
            <Table.Body>
              {analogueModel !== analogueModelDefault &&
              (analogueModel.fileUploads?.length === undefined ||
                analogueModel.fileUploads?.length > 0) ? (
                analogueModel.fileUploads
                  ?.filter(
                    (f) =>
                      f.uploadStatus !== UploadStatus.FAILED &&
                      f.uploadStatus !== UploadStatus.STARTED,
                  )
                  .map((file: UploadList) => (
                    <Table.Row key={file.uploadId} className="table-row">
                      <Styled.TableCell>
                        {file.originalFileName}
                      </Styled.TableCell>
                      <Table.Cell>-</Table.Cell>
                      <Table.Cell>
                        {iconButtons(file.uploadFileType)}
                      </Table.Cell>
                    </Table.Row>
                  ))
              ) : (
                <Table.Row>
                  <Table.Cell>No files uploaded</Table.Cell>
                  <Table.Cell>-</Table.Cell>
                </Table.Row>
              )}
              {analogueModel !== analogueModelDefault &&
              analogueModel.isProcessed === true &&
              analogueModel.fileUploads.filter(
                (x) =>
                  x.uploadFileType === UploadFileType.INI_DATA &&
                  x.uploadStatus === UploadStatus.COMPLETED,
              ).length !== 0 ? (
                <Table.Row>
                  <Table.Cell>Resqml.zip</Table.Cell>
                  <Table.Cell>-</Table.Cell>
                  <Table.Cell>
                    {iconButtons(UploadFileType.RES_QML_DATA)}
                  </Table.Cell>
                </Table.Row>
              ) : (
                <></>
              )}
            </Table.Body>
          </Styled.FileTable>
        </Styled.TableWrapper>
      </Card.Content>
    </Card>
  );
};
